import React, { useEffect, useState } from 'react';
import api from '../api';
import { Link } from 'react-router-dom';

export default function EventList() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get('/events/').then(r => setEvents(r.data));
  }, []);

  const now = new Date();
  const upcomingEvents = events.filter(e => new Date(e.start_date + 'T' + e.start_time) >= now);
  const pastEvents = events.filter(e => new Date(e.start_date + 'T' + e.start_time) < now);

  const EventCard = ({ e }) => (
    <div key={e.id} className="event-card">
      <div style={{
        height: '200px',
        backgroundColor: '#e5e7eb',
        borderRadius: '12px 12px 0 0',
        overflow: 'hidden',
        position: 'relative'
      }}>
        {e.image ? (
          <img
            src={e.image}
            alt={e.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#9ca3af',
            fontSize: '48px'
          }}>
            📅
          </div>
        )}
      </div>
      <div style={{ padding: '20px' }}>
        <h3 style={{ marginTop: 0, fontSize: '20px' }}>{e.name}</h3>
        <p style={{
          color: '#6b7280',
          fontSize: '14px',
          marginBottom: '16px',
          display: '-webkit-box',
          WebkitLineClamp: '3',
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        }}>
          {e.description}
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '13px', color: '#6366f1', fontWeight: '500' }}>
            {e.start_date}
          </span>
          <Link to={`/events/${e.uuid}`}>
            <button style={{ padding: '8px 16px', fontSize: '14px' }}>
              Manage
            </button>
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container animate-fade-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', borderBottom: '1px solid #e5e7eb', paddingBottom: '16px' }}>
        <h2 style={{ fontSize: '28px', margin: 0 }}>My Events</h2>
        <Link to="/events/new">
          <button>+ Create Event</button>
        </Link>
      </div>

      <h3 style={{ color: '#4b5563', marginBottom: '16px' }}>Upcoming</h3>
      {upcomingEvents.length === 0 ? <p style={{ color: '#888' }}>No upcoming events.</p> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px', marginBottom: '40px' }}>
          {upcomingEvents.map(e => <EventCard key={e.id} e={e} />)}
        </div>
      )}

      <h3 style={{ color: '#4b5563', marginBottom: '16px' }}>History</h3>
      {pastEvents.length === 0 ? <p style={{ color: '#888' }}>No past events.</p> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px', opacity: 0.8 }}>
          {pastEvents.map(e => <EventCard key={e.id} e={e} />)}
        </div>
      )}
    </div>
  );
}
